import {
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  ELSPendoService,
} from '@els/els-ui-common-react';
import { AppConstants } from '../app/app.constants';
import { AppContext } from '../app/AppProvider.component';
import {
  getPendoConfig,
} from './analytics-registrar.utilities';

const AnalyticsRegistrar = (): JSX.Element => {
  const { appState } = useContext(AppContext);
  const [isPendoLoaded, setIsPendoLoaded] = useState(false);

  useEffect(() => {
    ELSPendoService.injectScript(AppConstants.PENDO_API_KEY);

    // Poll for window.pendo to be available
    const checkPendo = setInterval(() => {
      if (window.pendo) {
        setIsPendoLoaded(true);
        clearInterval(checkPendo);
      }
    }, 100);

    // Cleanup: clear interval after 10 seconds if pendo never loads
    const timeout = setTimeout(() => {
      clearInterval(checkPendo);
    }, 10000);

    return () => {
      clearInterval(checkPendo);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    if (
      !isPendoLoaded
      || !window.pendo
      || !appState.currentCourse
      || !appState.evolveUser
      || !appState.eolsUser
    ) {
      return;
    }
    const config = getPendoConfig(appState);
    window.pendo.initialize(config);
  }, [
    isPendoLoaded,
    appState.currentCourse,
    appState.evolveUser,
    appState.eolsUser,
  ]);

  return null;
};

export default AnalyticsRegistrar;
